// ═══════════════════════════════════════════════════════════════════════════
// Pantalla de acceso — Etapa 3
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState } from "react";
import { entrarConLlave } from "./llaves.js";
import { entrar, registrar } from "./sesion.js";
import { nombreEntorno, esProduccion } from "./config.js";
import { LOGO_BASE64 } from "../pdf/logo.js";
import { btnPrimary, inputStyle } from "../ui/estilos.js";
import { APP_VERSION } from "../config/semilla.js";

// `ticket` llega cuando alguien abrió la liga de invitación. Es lo ÚNICO que
// habilita crear cuenta: sin él, esta pantalla solo deja entrar a quien ya
// existe. Una vinícola no quiere que cualquiera se registre y quede dando
// vueltas por dentro.
export function Login({ onEntrar, ticket, onRecuperar }) {
  const [modo, setModo] = useState(ticket ? "crear" : "entrar");
  const [avisoCorreo, setAvisoCorreo] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  // El rescate. Va detrás de un clic porque no es el camino de todos los días:
  // enseñarlo siempre invita a usar la llave para entrar a diario, y una llave
  // que se teclea todos los días acaba pegada en un monitor.
  const [conLlave, setConLlave] = useState(false);
  const [llave, setLlave] = useState("");

  const enviar = async (e) => {
    e.preventDefault();
    if (cargando) return;
    setCargando(true); setError(""); setAvisoCorreo(false);
    try {
      if (modo === "crear") {
        const { necesitaConfirmar } = await registrar(email, password);
        if (necesitaConfirmar) {
          // La cuenta existe pero todavía no puede entrar. Decirlo es
          // obligatorio: si no, el vendedor teclea su contraseña, no pasa
          // nada, y cree que se equivocó.
          setAvisoCorreo(true); setCargando(false); return;
        }
      }
      const r = await entrar(email, password);
      onEntrar(r);
    } catch (err) {
      setError(err.message);
      setCargando(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "#0a0a0a", padding: 16 }}>
      <form onSubmit={enviar} style={{ width: "100%", maxWidth: 360 }}>

        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img src={LOGO_BASE64} alt="" style={{ width: 78, height: 78, borderRadius: 12, objectFit: "cover" }} />
          <h1 style={{ margin: "14px 0 2px", fontSize: 20, color: "#e8e0d4", fontWeight: 600,
            fontFamily: "'Cormorant Garamond', serif", letterSpacing: 1 }}>
            Vinícola Total
          </h1>
          {!esProduccion() && (
            <div style={{ fontSize: 10, color: "#ec4899", letterSpacing: 2, marginTop: 4 }}>
              ENTORNO DE {nombreEntorno().toUpperCase()}
            </div>
          )}
        </div>

        <label style={{ fontSize: 11, color: "#666" }}>Correo</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)}
          autoComplete="username" autoCapitalize="none" required disabled={cargando}
          style={{ ...inputStyle, width: "100%", marginBottom: 12 }} />

        <label style={{ fontSize: 11, color: "#666" }}>Contraseña</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)}
          autoComplete={modo === "crear" ? "new-password" : "current-password"} required disabled={cargando}
          style={{ ...inputStyle, width: "100%", marginBottom: 16 }} />

        {error && (
          <div style={{ background: "#1f0d0d", border: "1px solid #3a1a1a", borderRadius: 6,
            padding: "10px 12px", marginBottom: 14, fontSize: 12, color: "#e8b0b0", whiteSpace: "pre-line" }}>
            {error}
          </div>
        )}

        {avisoCorreo && (
          <div style={{ background: "#12140d", border: "1px solid #2a3a1a", borderRadius: 6,
            padding: "12px 14px", marginBottom: 14, fontSize: 12, color: "#c9d8a0", lineHeight: 1.7 }}>
            Tu cuenta se creó. Te mandamos un correo a <b>{email}</b> para confirmarla:
            ábrelo, y después vuelve aquí a entrar con tu contraseña. Tu invitación
            sigue sirviendo.
          </div>
        )}

        <button type="submit" disabled={cargando}
          style={{ ...btnPrimary, width: "100%", opacity: cargando ? 0.6 : 1 }}>
          {cargando ? (modo === "crear" ? "Creando…" : "Entrando…")
                    : (modo === "crear" ? "Crear cuenta" : "Entrar")}
        </button>

        {ticket && (
          <button type="button"
            onClick={() => { setModo(modo === "crear" ? "entrar" : "crear"); setError(""); setAvisoCorreo(false); }}
            style={{ width: "100%", marginTop: 10, padding: "9px", fontSize: 12,
              background: "transparent", border: "1px solid #222", borderRadius: 6,
              color: "#888", cursor: "pointer" }}>
            {modo === "crear" ? "Ya tengo cuenta — entrar" : "No tengo cuenta — crear una"}
          </button>
        )}

        {modo !== "crear" && !conLlave && (
          <button type="button" onClick={() => { setConLlave(true); setError(""); }}
            style={{ width: "100%", marginTop: 12, padding: "9px", fontSize: 12,
                     background: "transparent", border: "1px solid #222", borderRadius: 6,
                     color: "#888", cursor: "pointer" }}>
            No puedo entrar
          </button>
        )}

        {modo !== "crear" && conLlave && (
          <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid #222" }}>
            <div style={{ fontSize: 12, color: "#888", lineHeight: 1.7, marginBottom: 10 }}>
              Si guardaste una <b style={{ color: "#aaa" }}>llave de acceso</b>, pégala
              aquí y entras sin contraseña.
            </div>
            <input type="password" value={llave} autoComplete="off"
              onChange={e => { setLlave(e.target.value); setError(""); }}
              placeholder="vt_…"
              style={{ ...inputStyle, width: "100%", fontFamily: "monospace",
                       marginBottom: 10 }} />
            <button type="button" disabled={cargando || llave.trim().length < 20}
              onClick={async () => {
                setCargando(true); setError("");
                try { await entrarConLlave(llave); setLlave(""); }
                catch (err) { setError(err.message); setCargando(false); }
              }}
              style={{ ...btnPrimary, width: "100%",
                       opacity: (cargando || llave.trim().length < 20) ? 0.5 : 1 }}>
              {cargando ? "Entrando…" : "Entrar con la llave"}
            </button>

            <button type="button" onClick={() => onRecuperar?.(email)}
              style={{ width: "100%", marginTop: 10, padding: "9px", fontSize: 12,
                       background: "transparent", border: "1px solid #222", borderRadius: 6,
                       color: "#777", cursor: "pointer" }}>
              No tengo llave — mandarme un correo
            </button>
            <div style={{ fontSize: 10, color: "#556", marginTop: 8, lineHeight: 1.6 }}>
              El correo puede tardar o caer en la carpeta de no deseado. La llave no
              depende de nada de eso: por eso es el camino recomendado.
            </div>

            <button type="button" onClick={() => { setConLlave(false); setError(""); }}
              style={{ width: "100%", marginTop: 10, padding: "7px", fontSize: 11,
                       background: "transparent", border: "none", color: "#555",
                       cursor: "pointer" }}>
              Volver
            </button>
          </div>
        )}

        <div style={{ marginTop: 18, fontSize: 10, color: "#444", textAlign: "center", lineHeight: 1.7 }}>
          v{APP_VERSION}
          <br />
          La primera vez en cada dispositivo necesitas conexión.
          <br />
          Después la sesión funciona sin internet.
        </div>
      </form>
    </div>
  );
}
